import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { FormBuilder, FormGroup, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import {
  ConfiguracaoVazaoHistorico,
  EstacaoDownloadListaEstacao,
  EstacaoDownloadListaPayload,
  EstacaoDownloadListaResponse,
  EstacaoService
} from 'src/services/estacao.service';
import { PessoaService } from 'src/services/pessoa.service';
import * as moment from 'moment';
import { ConfiguracaoEventoService } from 'src/services/configuracao-evento.service';
import { EstacaoConfiguradaEventoService } from 'src/services/estacao-configurada-evento.service';
import { Subscription } from 'rxjs';
import { ColetaService } from 'src/services/coleta.service';
import { PermissoesService } from 'src/services/permissoes.service';
import { ResumoEventoDiaService } from 'src/services/resumo-evento.service';
import { VariavelService } from 'src/services/variavel.service';
import { SensorService } from 'src/services/sensor.service';
import { EstacaoGrupoService } from 'src/services/estacao-grupos.service';
import { IntegracaoService } from 'src/services/integracao.service';
import { DescodificadorService } from 'src/services/descodificador.service';
import { TabView } from 'primeng/tabview';
import { OnixsatService } from 'src/services/onixsat.service';
import { MessageService, ConfirmationService } from 'primeng/api';
import * as FileSaver from 'file-saver';
import { TipoDescodificadorService } from 'src/services/tipo-descodificador.service';
import { IntegracaoEnvioService } from 'src/services/integracao-envio.service';
import { EstacaoLookupCacheService } from 'src/services/estacao-lookup-cache.service';
import { LambdaVazaoService } from 'src/services/lambda-vazao.service';

type EstacaoGridFilters = {
  search?: string;
  grupoList: number[];
  clienteList: number[];
  sensorList: number[];
  plu?: string | null;
  flu?: string | null;
  integradorList: number[];
  coletorList: number[];
  estacoes_ids?: number[];
};

type ReprocessamentoLogItem = {
  created_at?: string;
  mensagem?: string;
};

type ReprocessamentoListItem = {
  tipo?: string;
  status?: string;
  data_inicio?: string;
  data_fim?: string;
  tipo_variavel_labels?: string[];
  tipo_evento_labels?: string[];
  dias_total?: number;
  dias_processados?: number;
  progresso_pct?: number;
  mensagem?: string;
  logs?: ReprocessamentoLogItem[];
};

@Component({
    selector: 'app-estacao',
    templateUrl: './estacao.component.html',
    styleUrls: ['./estacao.component.scss'],
    standalone: false
})
export class EstacaoComponent implements OnInit, AfterViewInit, OnDestroy {
  loading: boolean = false
  displayModal: boolean = false
  modalDataRecalculo: boolean = false
  modalNovoGrupo: boolean = false
  data: any[] = []
  @ViewChild('tableWrapper', { static: false }) tableWrapper: ElementRef;
  scrollHeight: string = '400px';
  array_config: any[] = []
  array_config_copia: any[] = []
  array_config_coleta: any[] = []
  array_estacao_coletas: any[] = []
  array_estacao_coletas_copia: any[] = []
  dropDownConfiguracaoEvento: any[] = []
  dropDownSensores: any[] = []
  selectedConfiguracoes: any[] = []
  dropDownColetas: any[] = []
  dropDownTipoVariavel: any[] = []
  dropDownTipoDescodificacao: any[] = []
  form: FormGroup;
  dataRecalculo: any
  exibirFiltroAvancado: boolean = false
  modalReprocessamento: boolean = false
  modalConfirmacaoReprocessamento: boolean = false
  modalOpcoesReprocessamento: boolean = false
  modalPeriodoIntegracao: boolean = false
  modalProgressoIntegracao: boolean = false
  modalRecalcularVazao: boolean = false
  dataInicialRecalcularVazao: Date | null = null
  dataFinalRecalcularVazao: Date | null = null
  loadingRecalcularVazao: boolean = false
  estacaoReprocessamento: any = null
  dataHoraReprocessamento: Date | null = null
  dataFinalReprocessamentoColeta: Date | null = null
  dataInicialIntegracao: Date | null = null
  dataFinalIntegracao: Date | null = null
  dataMinima: Date = new Date()
  dataMaxima: Date = new Date()
  /** Sem limite artificial de 1 mês: permite histórico longo. */
  dataMinimaIntegracao: Date = new Date()
  loadingReprocessamento: boolean = false
  processandoIntegracao: boolean = false
  concluidoIntegracao: boolean = false
  /** Mensagem retornada pela API (campo message) para exibir no modal de progresso. */
  resultadoIntegracaoMensagem: string = ''
  /** 'success' | 'warn' para estilizar resultado (parcial/timeout = warn). */
  resultadoIntegracaoTipo: 'success' | 'warn' = 'success'
  listaReprocessamentos: ReprocessamentoListItem[] = []
  loadingListaReprocessamentos: boolean = false
  private pollReprocessamentosTimer: any = null
  dropDownGrupos: any[] = [];
  dropDownClientes: any[] = [];
  dropDownEstacoesFiltro: any[] = [];
  dropDownIntegradores: any[] = [];
  integracoes: any[] = [];
  integradorSelecionado: any;
  grupo: any
  estacoesFiltro: any[] = []
  sensor: any
  transmissorIdentificador: string = ''
  private sensorIdVinculado: number | null = null
  cliente: any

  plu_filtro: any
  flu_filtro: any
  integrador_filtro: any[] = []
  coletor_filtro: any[] = []
  dropDownColetores: any[] = []
  exibir_campo_ftp: boolean = false

  array_vazao: any[] = [];
  /** Cópia do array_vazao ao abrir a estação para edição; usada para detectar alteração no cálculo (faixas). */
  array_vazao_inicial: any[] = [];
  estadoVazaoInicial: any = null;
  configuracaoVazaoHistoricoOrigemId: number | null = null;
  historicoVazao: ConfiguracaoVazaoHistorico[] = [];
  historicoVazaoLoading: boolean = false;
  historicoVazaoCarregado: boolean = false;
  historicoVazaoErro: boolean = false;
  historicoVazaoIndisponivel: boolean = false;
  historicoVazaoTotal: number = 0;
  historicoVazaoPagina: number = 1;
  historicoVazaoPorPagina: number = 10;
  historicoVazaoFirst: number = 0;
  private historicoVazaoSubscription?: Subscription;
  user: any = {};
  isViewMode: boolean = false;

  cols_vazao = [
    { field: 'intervalo', header: 'Intervalo' },
    { field: 'valor_x', header: 'Valor a' },
    { field: 'valor_y', header: 'Valor H0' },
    { field: 'valor_z', header: 'Valor n' },
    { field: 'visualizacao_formula', header: 'Operação' },
  ]

  rows: number = 10
  perPage: number = 20;
  currentPage: number = 1;
  gridFirst: number = 0;
  totalRecords: number = 0;
  searchTerm: string = '';
  private searchDebounceHandle?: ReturnType<typeof setTimeout>;

  intervaloMinimo: number | null = null;
  intervaloMaximo: number | null = null;
  valorX: number | null = null;
  valorY: number | null = null;
  valorZ: number | null = null;

  array_integracao: any[] = [];
  novaIntegracao: any = {
    configuracao_estacao_id: null,
    configuracao_usuario_integracao: '',
    configuracao_senha_integracao: '',
    tag: '',
    configuracao_estacao_label: '',
  };
  private readonly CONFIGURACAO_INTEGRACAO_VALE_ECOS_ID = 11;
  cols_integracao = [
    { field: 'configuracao_estacao_id', header: 'Integrador' },
    { field: 'tag', header: 'Tag' },
    { field: 'configuracao_usuario_integracao', header: 'Usuário' },
  ];
  originalIntegrations: any[] = [];
  deletedIntegrations: any[] = []; // Array para armazenar integrações excluídas que têm id
  /** Modal de confirmação de exclusão: usuário deve digitar "Excluir estação" */
  modalExcluirEstacao: boolean = false;
  estacaoParaExcluir: any = null;
  inputExcluirEstacao: string = '';
  readonly textoConfirmacaoExclusaoEstacao = 'Excluir estação';
  /** ID da estação cujos dados estão sendo carregados para edição (evita múltiplos cliques no botão Editar). */
  idEstacaoCarregando: number | null = null;
  showCredenciaisDialog = false;
  credenciaisIntegracao: { label: string; usuario: string; senha: string } = { label: '', usuario: '', senha: '' };
  modalSnirhSerieHistorica: boolean = false;
  loadingSnirhSerieHistorica: boolean = false;
  snirhSerieHistoricaTitulo: string = 'Série histórica SNIRH';
  snirhSerieHistoricaHtml: SafeHtml | null = null;
  @ViewChild('tabView') tabView: TabView;

  constructor(
    protected _estacaoService: EstacaoService,
    private onixsatService: OnixsatService,
    private sanitizer: DomSanitizer,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    protected _configuracaoEventoService: ConfiguracaoEventoService,
    protected _estacaoConfiguradaService: EstacaoConfiguradaEventoService,
    protected _pessoaService: PessoaService,
    protected _formBuilder: FormBuilder,
    protected _coletaService: ColetaService,
    protected permissaoService: PermissoesService,
    protected _resumoEventoDiaService: ResumoEventoDiaService,
    protected _variavelService: VariavelService,
    protected _sensorService: SensorService,
    protected _estacaoGrupoService: EstacaoGrupoService,
    protected _integracaoService: IntegracaoService,
    protected _coletorService: ColetaService,
    protected _descodificadorService: DescodificadorService,
    protected _tipoDescodificadorService: TipoDescodificadorService,
    protected _integracaoEnvioService: IntegracaoEnvioService,
    private _lambdaVazaoService: LambdaVazaoService,
    private lookupCache: EstacaoLookupCacheService,
  ) { }

  ngOnInit(): void {
    this.user = JSON.parse(localStorage.getItem('user') ?? '{}');
    // Sem restrição de 1 mês: calendário aberto até hoje
    this.dataMaxima = new Date();
    this.dataMinima = new Date(2000, 0, 1);
    this.dataMinimaIntegracao = new Date(2000, 0, 1);
    this.form = this._formBuilder.group({
      id: [null],
      descricao: [null, Validators.required],
      cliente_id: [null, Validators.required],
      sensor_id: [null],
      plu: [null, Validators.required],
      flu: [null, Validators.required],
      tipo_integracao: [null],
      localizacao: [null, Validators.required],
      latitude: [null, Validators.required],
      longitude: [null, Validators.required],
      data_instalacao: [null, Validators.required],
      status: [null],
      indicie_ajuste: [null],
      acrescimo_decrescimo: [null],
      ativo: [null],
      estacao_monitorada_api: [null],
      exibir_vazao: [null],
      tipo_origem_vazao: [null],
      casas_decimais_vazao: [null, [Validators.min(0), Validators.max(10)]],
      vazao_x: [null],
      vazao_y: [null],
      vazao_z: [null],
      intervalo_operacao: [null, this.validarIntervaloOperacao],
      desativar_coleta: [false],
      desativar_integracao: [false],
    });

    // Desativar preserva a configuração; ao ativar sem origem definida, usa vazão calculada.
    this.form.get('exibir_vazao')?.valueChanges.subscribe((exibir: boolean | null) => {
      const ctrlTipo = this.form.get('tipo_origem_vazao');
      if (exibir && (ctrlTipo?.value === null || ctrlTipo?.value === undefined)) {
        ctrlTipo?.setValue(0, { emitEvent: false });
      }
    });

    this.form.get('intervalo_operacao')?.valueChanges.subscribe(() => {
      if (this.form.get('id')?.value == null) {
        this.aplicarCriterioPadraoPainelBaixaPotencia();
      }
    });

    this.loadLookupData();
  }

  /** Carrega dropdowns auxiliares (com cache de sessão). A grade principal vem do lazy load da tabela. */
  private loadLookupData(): void {
    this.listConfiguracaoEvento();
    this.listColetas();
    this.listVariaveis();
    this.listSensores();
    this.listGrupos();
    this.listEstacoesFiltro();
    this.listClientes();
    this.listIntegradores();
    this.listColetor();
    this.listTipoDescodificacao();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.calculateScrollHeight();
    }, 100);
  }

  ngOnDestroy(): void {
    this.cancelarCarregamentoLogs();
    this.cancelarCarregamentoHistoricoVazao();
    this.pararPollingReprocessamentos();
  }

  calculateScrollHeight(): void {
    if (this.tableWrapper && this.tableWrapper.nativeElement) {
      const wrapperHeight = this.tableWrapper.nativeElement.offsetHeight;
      // Subtrai apenas altura do caption (~60px) e paginator (~60px), header já está dentro do scrollable
      const calculatedHeight = wrapperHeight - 120;
      this.scrollHeight = `${Math.max(calculatedHeight, 300)}px`;
    }
  }

  get isUsuarioInterno(): boolean {
    return this.user?.usuario_interno === true;
  }

  get camposColetaDesabilitados(): boolean {
    return this.isViewMode || this.form?.get('desativar_coleta')?.value === true;
  }

  get camposIntegracaoDesabilitados(): boolean {
    return this.isViewMode || this.form?.get('desativar_integracao')?.value === true;
  }

  onDesativarColetaChange(): void {
    const desativarColeta = this.form?.get('desativar_coleta');
    const integracaoAtiva = !this.normalizarBoolean(this.form?.get('desativar_integracao')?.value);

    if (this.normalizarBoolean(desativarColeta?.value) && integracaoAtiva) {
      desativarColeta.setValue(false, { emitEvent: false });
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Não é possível desativar a coleta enquanto a integração estiver ativa. Desative a integração primeiro.',
      });
    }
  }

  onDesativarIntegracaoChange(): void {
    const desativarIntegracao = this.form?.get('desativar_integracao');
    const coletaDesativada = this.normalizarBoolean(this.form?.get('desativar_coleta')?.value);

    if (!this.normalizarBoolean(desativarIntegracao?.value) && coletaDesativada) {
      desativarIntegracao?.setValue(true, { emitEvent: false });
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Não é possível ativar a integração enquanto a coleta estiver desativada. Ative a coleta primeiro.',
      });
    }
  }

  private coletaIntegracaoEmEstadoValido(): boolean {
    const coletaDesativada = this.normalizarBoolean(this.form?.get('desativar_coleta')?.value);
    const integracaoAtiva = !this.normalizarBoolean(this.form?.get('desativar_integracao')?.value);

    return !(coletaDesativada && integracaoAtiva);
  }

  get integradorSelecionadoEhValeEcos(): boolean {
    return this.isIntegradorValeEcos(this.novaIntegracao?.configuracao_estacao_id);
  }

  get podeAdicionarIntegracao(): boolean {
    if (this.camposIntegracaoDesabilitados || !this.novaIntegracao?.configuracao_estacao_id) {
      return false;
    }
    if (this.integradorSelecionadoEhValeEcos) {
      return !!(this.novaIntegracao.tag || '').trim();
    }
    return !!(
      (this.novaIntegracao.configuracao_usuario_integracao || '').trim() &&
      (this.novaIntegracao.configuracao_senha_integracao || '').trim()
    );
  }

  private normalizarTextoIntegrador(valor: string): string {
    return (valor || '')
      .toUpperCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  private buscarIntegradorPorConfigId(configId: number | string | null | undefined): any | null {
    if (configId == null || configId === '') {
      return null;
    }
    const configIdNumero = Number(configId);
    return this.dropDownIntegradores.find((i: any) => Number(i.value) === configIdNumero) || null;
  }

  isIntegradorValeEcos(configId: number | string | null | undefined): boolean {
    if (configId == null || configId === '') {
      return false;
    }
    if (Number(configId) === this.CONFIGURACAO_INTEGRACAO_VALE_ECOS_ID) {
      return true;
    }
    const integrador = this.buscarIntegradorPorConfigId(configId);
    if (!integrador) {
      return false;
    }
    const label = this.normalizarTextoIntegrador(integrador.label);
    return label.includes('VALE ECOS');
  }

  abrirSerieHistoricaSnirh(codigo: string | number | null | undefined, tipo: 'PLU' | 'FLU'): void {
    const codigoNormalizado = String(codigo ?? '').trim();

    if (!codigoNormalizado) {
      return;
    }

    this.modalSnirhSerieHistorica = true;
    this.loadingSnirhSerieHistorica = true;
    this.snirhSerieHistoricaTitulo = `Série histórica SNIRH - ${tipo} ${codigoNormalizado}`;
    this.snirhSerieHistoricaHtml = null;

    this._estacaoService.getSnirhSerieHistorica(codigoNormalizado, tipo).subscribe({
      next: (response: any) => {
        this.snirhSerieHistoricaTitulo = response?.titulo || this.snirhSerieHistoricaTitulo;
        this.snirhSerieHistoricaHtml = this.sanitizer.bypassSecurityTrustHtml(response?.html || '');
        this.loadingSnirhSerieHistorica = false;
      },
      error: (error) => {
        this.loadingSnirhSerieHistorica = false;
        this.modalSnirhSerieHistorica = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Falha ao consultar SNIRH',
          detail: error?.error?.message || 'Não foi possível carregar a série histórica no momento.'
        });
      }
    });
  }

  /** Abre o dialog para visualizar usuário e senha do integrador (apenas usuario_interno). */
  abrirVisualizarCredenciais(row: any): void {
    this.credenciaisIntegracao = {
      label: row.configuracao_estacao_label || 'Integrador',
      usuario: '',
      senha: ''
    };
    if (row.id && this.form.get('id')?.value) {
      const estacaoId = this.form.get('id').value;
      this._estacaoService.getIntegracaoCredenciais(estacaoId, row.id).subscribe({
        next: (res: any) => {
          this.credenciaisIntegracao.usuario = res.configuracao_usuario_integracao ?? '';
          this.credenciaisIntegracao.senha = res.configuracao_senha_integracao ?? '';
          this.showCredenciaisDialog = true;
        },
        error: () => {
          this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'Não foi possível carregar as credenciais.' });
        }
      });
    } else {
      this.credenciaisIntegracao.usuario = row.configuracao_usuario_integracao ?? '';
      this.credenciaisIntegracao.senha = row.configuracao_senha_integracao ?? '';
      this.showCredenciaisDialog = true;
    }
  }

  validarIntervaloOperacao(control: AbstractControl): ValidationErrors | null {
    if (!control.value || control.value === null || control.value === '') {
      return null; // Campo opcional, null é válido
    }

    const valor = Number(control.value);
    
    // Verifica se é um número válido
    if (isNaN(valor) || valor <= 0) {
      return { intervaloInvalido: true };
    }

    // Valores especiais: 5, 15, 30
    if (valor === 5 || valor === 15 || valor === 30) {
      return null; // Válido
    }

    // Múltiplos de 60: 60, 120, 180, 240, etc.
    if (valor % 60 === 0) {
      return null; // Válido
    }

    // Se não atender nenhuma condição, é inválido
    return { intervaloInvalido: true };
  }

  resetTabs() {
    if (this.tabView) {
      this.tabView.activeIndex = 0;
    }
  }

  get exibir_vazao(): boolean {
    return this.form?.get('exibir_vazao')?.value;
  }

  alternarAtivacaoVazao(): void {
    if (this.isViewMode) return;
    this.form.get('exibir_vazao')?.setValue(!this.exibir_vazao);
  }

  /** True quando os campos de cálculo de vazão (fórmula, botão Inserir, grid) devem estar habilitados: exibir_vazao marcado e "Vazão calculada" (0). */
  get exibirCamposCalculoVazao(): boolean {
    return !!this.form?.get('exibir_vazao')?.value && this.form?.get('tipo_origem_vazao')?.value === 0;
  }

  /** Compara dois valores numéricos (ex.: 1 e 1.0). */
  private mesmoValorNumerico(a: any, b: any): boolean {
    if (a == null && b == null) return true;
    if (a == null || b == null) return false;
    return Number(a) === Number(b);
  }

  /** True se o array de faixas de vazão foi alterado em relação ao carregado (apenas para estação já existente). */
  get houveAlteracaoCalculoVazao(): boolean {
    if (this.array_vazao_inicial.length !== this.array_vazao.length) return true;
    const iniciais = this.array_vazao_inicial;
    const atuais = this.array_vazao;
    return atuais.some((item, i) => {
      const ini = iniciais[i];
      if (!ini) return true;
      return !this.mesmoValorNumerico(item.intervalo_inical, ini.intervalo_inical) ||
        !this.mesmoValorNumerico(item.intervalo_final, ini.intervalo_final) ||
        !this.mesmoValorNumerico(item.valor_x, ini.valor_x) ||
        !this.mesmoValorNumerico(item.valor_y, ini.valor_y) ||
        !this.mesmoValorNumerico(item.valor_z, ini.valor_z);
    });
  }

  /** Exibe a mensagem de aviso sobre alteração no cálculo (apenas estação existente, vazão calculada e faixas alteradas). */
  get exibirMensagemAlteracaoCalculoVazao(): boolean {
    const id = this.form?.get('id')?.value;
    if (id == null || id === '') return false;
    if (this.form?.get('tipo_origem_vazao')?.value !== 0) return false;
    return this.houveAlteracaoCalculoVazao;
  }

  private capturarEstadoVazaoFormulario(): any {
    const faixas = this.array_vazao.map((item: any) => ({
      intervalo_inical: Number(item.intervalo_inical),
      intervalo_final: Number(item.intervalo_final),
      valor_x: Number(item.valor_x),
      valor_y: Number(item.valor_y),
      valor_z: Number(item.valor_z),
    })).sort((a, b) => JSON.stringify(a).localeCompare(JSON.stringify(b)));

    const tipo = this.form?.get('tipo_origem_vazao')?.value;
    const casas = this.form?.get('casas_decimais_vazao')?.value;
    return {
      ativo: !!this.form?.get('exibir_vazao')?.value,
      tipo_origem_vazao: tipo == null ? null : Number(tipo),
      casas_decimais_vazao: casas == null ? null : Number(casas),
      faixas,
    };
  }

  get possuiAlteracoesVazaoNaoSalvas(): boolean {
    return this.estadoVazaoInicial != null
      && JSON.stringify(this.capturarEstadoVazaoFormulario()) !== JSON.stringify(this.estadoVazaoInicial);
  }

  carregarHistoricoVazao(page = 1): void {
    const estacaoId = Number(this.form?.get('id')?.value);
    if (!estacaoId || this.historicoVazaoLoading) return;

    this.cancelarCarregamentoHistoricoVazao();
    this.historicoVazaoLoading = true;
    this.historicoVazaoErro = false;
    this.historicoVazaoIndisponivel = false;
    this.historicoVazaoSubscription = this._estacaoService
      .historicoConfiguracoesVazao(estacaoId, page, this.historicoVazaoPorPagina)
      .subscribe({
        next: response => {
          this.historicoVazao = response?.data || [];
          this.historicoVazaoTotal = response?.total || 0;
          this.historicoVazaoPagina = response?.current_page || page;
          this.historicoVazaoPorPagina = response?.per_page || this.historicoVazaoPorPagina;
          this.historicoVazaoFirst = (this.historicoVazaoPagina - 1) * this.historicoVazaoPorPagina;
          this.historicoVazaoCarregado = true;
          this.historicoVazaoErro = false;
          this.historicoVazaoIndisponivel = false;
          this.historicoVazaoLoading = false;
          this.historicoVazaoSubscription = undefined;
        },
        error: (error) => {
          this.historicoVazao = [];
          this.historicoVazaoTotal = 0;
          this.historicoVazaoCarregado = true;
          this.historicoVazaoIndisponivel = error?.status === 404;
          this.historicoVazaoErro = !this.historicoVazaoIndisponivel;
          this.historicoVazaoLoading = false;
          this.historicoVazaoSubscription = undefined;
          if (!this.historicoVazaoIndisponivel) {
            this.messageService.add({
              severity: 'error',
              summary: 'Erro',
              detail: 'Não foi possível carregar o histórico de configurações de vazão.',
            });
          }
        },
      });
  }

  onHistoricoVazaoPage(event: any): void {
    const rows = Number(event?.rows) || this.historicoVazaoPorPagina;
    this.historicoVazaoPorPagina = rows;
    this.carregarHistoricoVazao(Math.floor((Number(event?.first) || 0) / rows) + 1);
  }

  reutilizarConfiguracaoVazao(historico: ConfiguracaoVazaoHistorico): void {
    if (this.isViewMode) return;

    const aplicar = () => this.aplicarConfiguracaoVazaoHistorica(historico);
    if (!this.possuiAlteracoesVazaoNaoSalvas) {
      aplicar();
      return;
    }

    this.confirmationService.confirm({
      key: 'globalConfirm',
      header: 'Reutilizar configuração de vazão',
      message: 'As alterações de vazão ainda não salvas serão substituídas. Deseja continuar?',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Reutilizar',
      rejectLabel: 'Cancelar',
      accept: aplicar,
    });
  }

  private aplicarConfiguracaoVazaoHistorica(historico: ConfiguracaoVazaoHistorico): void {
    this.array_vazao = (historico.faixas || []).map(faixa => ({
      intervalo: `${faixa.intervalo_inical}-${faixa.intervalo_final}`,
      intervalo_inical: Number(faixa.intervalo_inical),
      intervalo_final: Number(faixa.intervalo_final),
      valor_x: Number(faixa.valor_x),
      valor_y: Number(faixa.valor_y),
      valor_z: Number(faixa.valor_z),
    }));
    this.form.patchValue({
      exibir_vazao: historico.ativo,
      tipo_origem_vazao: historico.tipo_origem_vazao,
      casas_decimais_vazao: historico.casas_decimais_vazao,
    });
    this.configuracaoVazaoHistoricoOrigemId = historico.id;
    this.messageService.add({
      severity: 'info',
      summary: 'Configuração carregada',
      detail: 'Confira os valores e salve a estação para aplicar esta configuração.',
    });
  }

  private cancelarCarregamentoHistoricoVazao(): void {
    this.historicoVazaoSubscription?.unsubscribe();
    this.historicoVazaoSubscription = undefined;
    this.historicoVazaoLoading = false;
  }

  private resetarHistoricoVazao(): void {
    this.cancelarCarregamentoHistoricoVazao();
    this.historicoVazao = [];
    this.historicoVazaoTotal = 0;
    this.historicoVazaoPagina = 1;
    this.historicoVazaoFirst = 0;
    this.historicoVazaoCarregado = false;
    this.historicoVazaoErro = false;
    this.historicoVazaoIndisponivel = false;
    this.configuracaoVazaoHistoricoOrigemId = null;
    this.estadoVazaoInicial = null;
  }

  adicionarIntegracao() {
    if (this.novaIntegracao.configuracao_estacao_id) {
      const configId = this.novaIntegracao.configuracao_estacao_id;
      if (this.array_integracao.some((i: any) => i.configuracao_estacao_id === configId)) {
        this.messageService.add({ severity: 'warn', summary: 'Aviso', detail: 'Esta integração já foi adicionada ao grid.' });
        return;
      }
      const integradorSelecionado = this.buscarIntegradorPorConfigId(configId);
      const ehValeEcos = this.isIntegradorValeEcos(configId);

      const novaIntegracao = {
        configuracao_estacao_id: Number(configId),
        configuracao_estacao_label: integradorSelecionado?.label || '',
        configuracao_usuario_integracao: ehValeEcos
          ? null
          : this.novaIntegracao.configuracao_usuario_integracao,
        configuracao_senha_integracao: ehValeEcos
          ? null
          : this.novaIntegracao.configuracao_senha_integracao,
        tag: ehValeEcos
          ? (this.novaIntegracao.tag || '').trim()
          : null,
      };
      
      // Verificar se esta integração estava no array de exclusões e removê-la
      // Isso acontece quando o usuário remove uma integração e depois adiciona novamente
      this.deletedIntegrations = this.deletedIntegrations.filter(deleted => {
        // Verificar se há alguma integração original com o mesmo configuracao_estacao_id e usuario
        const originalIntegration = this.originalIntegrations.find(orig => 
          orig.configuracao_estacao_id === novaIntegracao.configuracao_estacao_id &&
          (
            this.isIntegradorValeEcos(novaIntegracao.configuracao_estacao_id)
              ? orig.tag === novaIntegracao.tag
              : orig.configuracao_usuario_integracao === novaIntegracao.configuracao_usuario_integracao
          )
        );
        // Se encontrou a integração original e ela está no deletedIntegrations, remover
        if (originalIntegration && deleted.id === originalIntegration.id) {
          return false; // Remove do array de exclusões
        }
        return true; // Mantém no array de exclusões
      });
      
      this.array_integracao.push(novaIntegracao);
      
      this.novaIntegracao = {
        configuracao_estacao_id: null,
        configuracao_estacao_label: '',
        configuracao_usuario_integracao: '',
        configuracao_senha_integracao: '',
        tag: '',
      };
    }
  }

  removerIntegracao(item: any) {
    const index = this.array_integracao.findIndex(integracao => 
      integracao.configuracao_estacao_id === item.configuracao_estacao_id &&
      (
        this.isIntegradorValeEcos(item.configuracao_estacao_id)
          ? integracao.tag === item.tag
          : integracao.configuracao_usuario_integracao === item.configuracao_usuario_integracao
      )
    );
    if (index !== -1) {
      // Se a integração tem id (já está salva no banco), adiciona ao array de exclusão
      if (item.id) {
        this.deletedIntegrations.push({
          id: item.id,
          deletedAt: true
        });
      }
      // Remove do array principal
      this.array_integracao.splice(index, 1);
    }
  }

  onIntegradorChange(event: any) {
    const selected = event?.value ?? event;
    const integradorSelecionado = this.buscarIntegradorPorConfigId(selected);
    this.novaIntegracao.configuracao_estacao_id = selected != null ? Number(selected) : null;
    this.novaIntegracao.configuracao_estacao_label = integradorSelecionado?.label || '';
    this.novaIntegracao.configuracao_usuario_integracao = '';
    this.novaIntegracao.configuracao_senha_integracao = '';
    this.novaIntegracao.tag = '';
  }

  adicionarVazao() {
    if (this.intervaloMinimo !== null && this.intervaloMaximo !== null && 
        this.valorX !== null && this.valorY !== null && this.valorZ !== null) {
        this.array_vazao.push({
          intervalo: this.intervaloMinimo + '-' + this.intervaloMaximo,
          intervalo_inical: this.intervaloMinimo,
          intervalo_final: this.intervaloMaximo,
          valor_x: this.valorX,
          valor_y: this.valorY,
          valor_z: this.valorZ
        });

        this.limparCamposVazao();
    } else {
      console.warn('Preencha todos os campos antes de inserir');
    }
  }

  limparCamposVazao() {
    this.intervaloMinimo = null;
    this.intervaloMaximo = null;
    this.valorX = null;
    this.valorY = null;
    this.valorZ = null;
  }

  toggleCamposVazao(exibir: boolean): void {
    const camposVazao = ['vazao_x', 'vazao_y', 'vazao_z'];
    
    camposVazao.forEach(campo => {
      if (exibir) {
        this.form.get(campo).enable();
      } else {
        this.form.get(campo).disable();
        this.form.get(campo).setValue(null);
      }
    });
  }

  listIntegradores(forceRefresh = false){
    const cacheKey = 'integradores';
    if (!forceRefresh && this.lookupCache.has(cacheKey)) {
      this.dropDownIntegradores = this.lookupCache.get<any[]>(cacheKey) || [];
      return;
    }

    this.dropDownIntegradores = []
    this._integracaoService.index().subscribe(json => {
      json.map(item => {
        this.dropDownIntegradores.push({
          value: item.id,
          label: item.descricao,
          tipo_integracao_id: item.tipo_integracao_id ?? null
        })
      })
      this.lookupCache.set(cacheKey, this.dropDownIntegradores);
    })
  }

  listColetor(forceRefresh = false){
    const cacheKey = 'coletores';
    if (!forceRefresh && this.lookupCache.has(cacheKey)) {
      this.dropDownColetores = this.lookupCache.get<any[]>(cacheKey) || [];
      return;
    }

    this._coletorService.index().subscribe(json => {
      this.dropDownColetores = json;
      this.lookupCache.set(cacheKey, this.dropDownColetores);
    })
  }

  getColumnStyle(field: string) {
    if (field === 'intervalo') {
      return { 'background-color': '#efefef', 'width': '20%' };
    } else if (field === 'visualizacao_formula') {
      return { 'background-color': '#efefef', 'width': '30%' };
    } else {
      return { 'background-color': '#efefef', 'width': '15%' };
    }
  }

  getColumnStyleBody(field: string) {
    if (field === 'intervalo') {
      return { 'background-color': 'aliceblue', 'width': '20%' };
    } else if (field === 'visualizacao_formula') {
      return { 'background-color': 'aliceblue', 'width': '30%' };
    } else {
      return { 'background-color': 'aliceblue', 'width': '15%' };
    }
  }

  addVazao() {
    
  }

  removeVazao(item: any) {
    const index = this.array_vazao.findIndex(vazao => 
      vazao.intervalo_inical === item.intervalo_inical &&
      vazao.intervalo_final === item.intervalo_final &&
      vazao.valor_x === item.valor_x &&
      vazao.valor_y === item.valor_y &&
      vazao.valor_z === item.valor_z
    );

    if (index !== -1) {
      this.array_vazao.splice(index, 1);
    }
  }

  filtrar(){
    this.currentPage = 1;
    this.gridFirst = 0;
    this.loadGridData(1, this.perPage);
  }

  listClientes(forceRefresh = false){
    const cacheKey = 'clientes';
    if (!forceRefresh && this.lookupCache.has(cacheKey)) {
      this.dropDownClientes = this.lookupCache.get<any[]>(cacheKey) || [];
      return;
    }

    this.dropDownClientes = []
    this._pessoaService.index().subscribe(json => {
      const ret = json.filter(x => x.ativo == true)
      ret.map(item => {
        this.dropDownClientes.push({
          label: item.nome, value: Number(item.id)
        })
      })
      this.dropDownClientes.sort((a, b) =>
        a.label.localeCompare(b.label, 'pt-BR', { sensitivity: 'base' })
      )
      this.lookupCache.set(cacheKey, this.dropDownClientes);
    })
  }

  listEstacoesFiltro(forceRefresh = false): void {
    const cacheKey = 'estacoes-filtro-exportacao';
    if (!forceRefresh && this.lookupCache.has(cacheKey)) {
      this.dropDownEstacoesFiltro = this.lookupCache.get<any[]>(cacheKey) || [];
      return;
    }

    this.dropDownEstacoesFiltro = [];
    this._estacaoService.lookup().subscribe((json: any) => {
      const estacoes = json?.data || json || [];
      this.dropDownEstacoesFiltro = estacoes.map((item: any) => ({
        label: item.descricao || `Estação ${item.id}`,
        value: Number(item.id)
      })).sort((a: any, b: any) =>
        a.label.localeCompare(b.label, 'pt-BR', { sensitivity: 'base' })
      );
      this.lookupCache.set(cacheKey, this.dropDownEstacoesFiltro);
    });
  }

  toggleFiltroAvancado(): void {
    this.exibirFiltroAvancado = !this.exibirFiltroAvancado;
  }

  
  listGrupos(forceRefresh = false){
    const cacheKey = 'grupos';
    if (!forceRefresh && this.lookupCache.has(cacheKey)) {
      this.dropDownGrupos = this.lookupCache.get<any[]>(cacheKey) || [];
      return;
    }

    this.dropDownGrupos = []
    this._estacaoGrupoService.index().subscribe(json => {
      json.map(item => {
        this.dropDownGrupos.push({
          label: item.nome, value: item.id
        })
      })
      this.lookupCache.set(cacheKey, this.dropDownGrupos);
    })
  }

  listColetas(forceRefresh = false){
    const cacheKey = 'coletas';
    if (!forceRefresh && this.lookupCache.has(cacheKey)) {
      this.dropDownColetas = this.lookupCache.get<any[]>(cacheKey) || [];
      return;
    }

    this.dropDownColetas = [{
      value: 'null', label: 'Selecione'
    }]
    this._coletaService.index().subscribe(json => {
      json.map(item => {
        this.dropDownColetas.push({
          value: item.id, label: item.descricao, tipo_coleta_id: item.tipo_coleta_id,
        })
      })
      this.lookupCache.set(cacheKey, this.dropDownColetas);
    })
  }

  listTipoDescodificacao(forceRefresh = false){
    const cacheKey = 'tipoDescodificacao';
    if (!forceRefresh && this.lookupCache.has(cacheKey)) {
      this.dropDownTipoDescodificacao = this.lookupCache.get<any[]>(cacheKey) || [];
      return;
    }

    this.dropDownTipoDescodificacao = [{
      value: null, label: 'Selecione'
    }]
    this._descodificadorService.index().subscribe(json => {
      json.map(item => {
        this.dropDownTipoDescodificacao.push({
          value: item.id, label: item.descricao
        })
      })
      this.lookupCache.set(cacheKey, this.dropDownTipoDescodificacao);
    })
  }

  listSensores(forceRefresh = false){
    const cacheKey = 'sensores';
    if (!forceRefresh && this.lookupCache.has(cacheKey)) {
      this.dropDownSensores = this.lookupCache.get<any[]>(cacheKey) || [];
      return;
    }

    this.dropDownSensores = [{
      value: 'null', label: 'Selecione'
    }]
    this._sensorService.index().subscribe(json => {
      json.map(item => {
        this.dropDownSensores.push({
          value: item.id, label: item.descricao,
        })
      })
      this.lookupCache.set(cacheKey, this.dropDownSensores);
    })
  }

  private applyConfiguracaoEventoFromApi(json: any[]): void {
    this.dropDownConfiguracaoEvento = []
    this.array_config = []
    json.map(item => {
      if(item.ativo == true){
        this.dropDownConfiguracaoEvento.push({
          value: item.id, label: item.descricao_evento, valor_padrao: item.valor_padrao, tipo_coleta_id: item.tipo_coleta_id
        })

        if(this.form.get('id').value == null){
          this.array_config.push({
            configuracao_evento_id: item.id,
            frequencia_em_minutos: null,
            valor_parametro: null,
            quantidade_anterior_acumular: null,
            valor_minimo: null,
            valor_padrao: item.valor_padrao,
            valor_maximo: null,
            criterio_diario: Number(item.id) === 2
              ? this.calcularCriterioPainelBaixaPotencia(this.form.get('intervalo_operacao')?.value)
              : null,
            quantidade_parametro_diario: null,
            ativo: true,
            recalculo: null,
            ...(Number(item.id) === 2
              ? { tipo_criterio_min_max: 0, tipo_criterio_pelo_irregural_regular: 1 }
              : {}),
          })
        } else {
          this.array_config.push({
            configuracao_evento_id: item.id,
            frequencia_em_minutos: null,
            valor_parametro: null,
            quantidade_anterior_acumular: null,
            valor_minimo: null,
            valor_padrao: item.valor_padrao,
            valor_maximo: null,
            criterio_diario: null,
            quantidade_parametro_diario: null,
            ativo: true,
            recalculo: false,
          })
        }
      }
    })
  }

  listConfiguracaoEvento(forceRefresh = false){
    const cacheKey = 'configuracaoEvento';
    if (!forceRefresh && this.lookupCache.has(cacheKey)) {
      this.applyConfiguracaoEventoFromApi(this.lookupCache.get<any[]>(cacheKey) || []);
      return;
    }

    this._configuracaoEventoService.index().subscribe(json => {
      this.lookupCache.set(cacheKey, json);
      this.applyConfiguracaoEventoFromApi(json);
    })
  }

  changeConfiguracao(event){
    let x = this.dropDownConfiguracaoEvento.find(x => x.value == event.configuracao_evento_id)
    event.valor_padrao = x.valor_padrao
    this.updateSelectedConfiguracoes()
  }

  changeConfiguracaoColeta(event){
    if(event.tipo_coleta_id == 2){
      this.exibir_campo_ftp = true
    } else {
      this.exibir_campo_ftp = false
    }
  }

  /** Retorna true quando o item deve exibir o campo "Nome do arquivo" (tipo_coleta_id = 2). */
  isTipoColetaId2(item: any): boolean {
    const configuracaoColetaId = item?.configuracao_coleta_id != null && typeof item.configuracao_coleta_id === 'object'
      ? item.configuracao_coleta_id?.value ?? null
      : item?.configuracao_coleta_id ?? null;
    if (configuracaoColetaId == null || configuracaoColetaId === 'null') return false;
    const opcao = this.dropDownColetas.find(c => c.value === configuracaoColetaId || c.value === +configuracaoColetaId);
    return opcao?.tipo_coleta_id === 2;
  }

  estacao: any;
  logs: any[] = [];
  logsTotalRecords: number = 0;
  rowsLogs: number = 50;
  logsCurrentPage: number = 1;
  logsLoaded: boolean = false;
  loadingLogs: boolean = false;
  private logsSubscription?: Subscription;
  private logsLoadRequestId = 0;

  onPageChange(event: any) {
    const estacaoId = this.form.get('id')?.value || this.estacao?.id;
    if (estacaoId) {
      this.iniciarCarregamentoLogs(estacaoId, event.page + 1);
    }
  }

  private cancelarCarregamentoLogs(): void {
    this.logsLoadRequestId++;
    if (this.logsSubscription) {
      this.logsSubscription.unsubscribe();
      this.logsSubscription = undefined;
    }
    this.loadingLogs = false;
  }

  private iniciarCarregamentoLogs(estacaoId: number, page: number = 1): void {
    if (!estacaoId || !this.displayModal) {
      return;
    }

    this.cancelarCarregamentoLogs();
    const requestId = this.logsLoadRequestId;
    this.loadingLogs = true;

    if (page === 1) {
      this.logsLoaded = false;
      this.logs = [];
      this.logsTotalRecords = 0;
    }

    this.logsSubscription = this._estacaoService.integracaoLogs(estacaoId, page).subscribe({
      next: (response: any) => {
        if (requestId !== this.logsLoadRequestId || !this.displayModal) {
          return;
        }

        this.logs = response?.data || [];
        this.logsTotalRecords = response?.total || 0;
        this.rowsLogs = response?.per_page || 50;
        this.logsCurrentPage = response?.current_page || page;
        this.logsLoaded = true;
        this.loadingLogs = false;
        this.logsSubscription = undefined;
      },
      error: () => {
        if (requestId !== this.logsLoadRequestId || !this.displayModal) {
          return;
        }

        this.logs = [];
        this.logsTotalRecords = 0;
        this.logsLoaded = true;
        this.loadingLogs = false;
        this.logsSubscription = undefined;
      }
    });
  }

  onTabChange(event: any): void {
    this.activeTabIndex = event.index;
    if (event.index === 4 && !this.historicoVazaoCarregado && this.form?.get('id')?.value) {
      this.carregarHistoricoVazao(1);
    }
  }

  /**
   * Abre o modal de confirmação de exclusão. O usuário deve digitar "Excluir estação" para confirmar.
   */
  excluir(estacao: any): void {
    this.estacaoParaExcluir = estacao;
    this.inputExcluirEstacao = '';
    this.modalExcluirEstacao = true;
  }

  fecharModalExcluirEstacao(): void {
    this.modalExcluirEstacao = false;
    this.estacaoParaExcluir = null;
    this.inputExcluirEstacao = '';
  }

  executarExclusaoEstacao(): void {
    if (!this.estacaoParaExcluir || this.inputExcluirEstacao !== this.textoConfirmacaoExclusaoEstacao) return;
    const id = this.estacaoParaExcluir.id;
    this.fecharModalExcluirEstacao();
    this._estacaoService.excluir(id).subscribe({
      next: () => {
        this.index();
        this.listEstacoesFiltro(true);
        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: 'Estação excluída com sucesso.',
        });
      },
      error: (error) => {
        console.error('Erro ao excluir estação:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: error?.error?.message || 'Erro ao excluir estação.',
        });
      },
    });
  }

  private normalizarBoolean(valor: any): boolean {
    if (valor === true || valor === 1 || valor === '1') {
      return true;
    }
    if (typeof valor === 'string') {
      const normalizado = valor.trim().toLowerCase();
      return normalizado === 'true' || normalizado === 't' || normalizado === 'yes' || normalizado === 'on';
    }
    return false;
  }

  private calcularCriterioPainelBaixaPotencia(intervaloOperacao: any): number {
    const intervalo = Number(intervaloOperacao);
    const minutos = !intervalo || intervalo <= 0 ? 60 : intervalo;
    const ciclos = Math.floor(1440 / minutos);
    return Math.max(1, Math.round((4 * ciclos) / 24));
  }

  private aplicarCriterioPadraoPainelBaixaPotencia(): void {
    const criterio = this.calcularCriterioPainelBaixaPotencia(this.form?.get('intervalo_operacao')?.value);
    (this.array_config || []).forEach((item: any) => {
      if (Number(item?.configuracao_evento_id) === 2) {
        item.criterio_diario = criterio;
        item.tipo_criterio_min_max = 0;
        item.tipo_criterio_pelo_irregural_regular = 1;
      }
    });
  }

  private normalizarAtivoConfiguracaoEvento(valor: any): boolean {
    return valor == null ? true : this.normalizarBoolean(valor);
  }

  private prepararConfiguracoesEventoParaEnvio(configuracoes: any[] = this.array_config): any[] {
    const criterioPainel = this.calcularCriterioPainelBaixaPotencia(this.form?.get('intervalo_operacao')?.value);
    return configuracoes.map((item: any) => {
      const payload: any = {
        ...item,
        ativo: this.normalizarAtivoConfiguracaoEvento(item?.ativo),
      };

      if (Number(item?.configuracao_evento_id) === 2) {
        payload.tipo_criterio_min_max = 0;
        payload.tipo_criterio_pelo_irregural_regular = 1;
        if (payload.criterio_diario == null || payload.criterio_diario === '') {
          payload.criterio_diario = criterioPainel;
        }
      }

      return payload;
    });
  }

  private normalizarTipoOrigemVazao(exibirVazao: any, tipoOrigemVazao: any): number | null {
    if (tipoOrigemVazao !== null && tipoOrigemVazao !== undefined && tipoOrigemVazao !== '') {
      return Number(tipoOrigemVazao) === 1 ? 1 : 0;
    }

    return this.normalizarBoolean(exibirVazao) ? 0 : null;
  }

  edit(event){
    if (this.idEstacaoCarregando != null) return;
    this.cancelarCarregamentoLogs();
    this.resetarHistoricoVazao();
    this.idEstacaoCarregando = event.id;
    this.isViewMode = !this.isUsuarioInterno;
    this.array_config_coleta = []
    this.array_vazao=[]
    this.logs = [];
    this.logsTotalRecords = 0;
    this.rowsLogs = 50;
    this.logsCurrentPage = 1;
    this.logsLoaded = false;
    this.loadingLogs = false;
    this.activeTabIndex = 0;
    this.form.reset();
    this._estacaoService.formData(event.id).subscribe({
      next: (json) => {
      const estacao = json.estacao;
      this.estacao = estacao;
      const exibirVazao = this.normalizarBoolean(estacao.exibir_vazao);
      const tipoOrigemVazao = this.normalizarTipoOrigemVazao(estacao.exibir_vazao, estacao.tipo_origem_vazao);
      if(estacao.status == 0){
        this.form.get('ativo').setValue(true)
      } else {
        this.form.get('ativo').setValue(false)
      }

      if (estacao.configuracoes_vazao) {
        estacao.configuracoes_vazao.map(element => {
          this.array_vazao.push({
            intervalo: element.intervalo_inical+'-'+element.intervalo_final,
            intervalo_inical: element.intervalo_inical,
            intervalo_final: element.intervalo_final,
            valor_x: element.valor_x,
            valor_y: element.valor_y,
            valor_z: element.valor_z,
          })
        })
        this.array_vazao_inicial = this.array_vazao.map(item => ({
          intervalo_inical: item.intervalo_inical,
          intervalo_final: item.intervalo_final,
          valor_x: item.valor_x,
          valor_y: item.valor_y,
          valor_z: item.valor_z,
        }))
      } else {
        this.array_vazao_inicial = []
      }

      if (estacao.configuracao_integracao_estacoes) {
        // Limpar array de exclusões ao editar uma nova estação
        this.deletedIntegrations = [];
        this.array_integracao = estacao.configuracao_integracao_estacoes.map(item => {
          const integrador = this.dropDownIntegradores.find(i => i.value === item.configuracao_integracao_id);
          return {
            id: item.id, // Salvar o id da configuração de integração
            estacao_id: estacao.id,
            configuracao_estacao_id: item.configuracao_integracao_id,
            configuracao_estacao_label: integrador?.label || '',
            configuracao_usuario_integracao: item.configuracao_usuario_integracao || '',
            tag: item.tag || '',
          };
        });
        this.originalIntegrations = [...this.array_integracao];
      }

      if (estacao.configuracoes_integracao) {
        const idsIntegracoes = estacao.configuracoes_integracao.map(item => item.id);
        
        this.integracoes = this.dropDownIntegradores.filter(integrador => 
          idsIntegracoes.includes(integrador.value)
        );
      }

      if(estacao.exibir_vazao != null){
        this.form.get('exibir_vazao').setValue(exibirVazao)
        if(estacao.vazao_x != null){
          this.form.get('vazao_x').setValue(estacao.vazao_x)
        }
  
        if(estacao.vazao_y != null){
          this.form.get('vazao_y').setValue(estacao.vazao_y)
        }
  
        if(estacao.vazao_z != null){
          this.form.get('vazao_z').setValue(estacao.vazao_z)
        }
      }


      if(estacao.data_instalacao){
        estacao.data_instalacao = moment.utc(estacao.data_instalacao).format('YYYY-MM-DD')
      }
      this.form.patchValue({
        ...estacao,
        exibir_vazao: exibirVazao,
        tipo_origem_vazao: tipoOrigemVazao,
        desativar_coleta: estacao.desativar_coleta === true,
        desativar_integracao: estacao.desativar_integracao === true,
      })
      this.estadoVazaoInicial = this.capturarEstadoVazaoFormulario();
      if (estacao.cliente) {
        this.form.get('cliente_id').setValue(Number(estacao.cliente.id))
      }

      if(estacao.configuracoes_evento){
        estacao.configuracoes_evento.map(item => {
          let cfg = this.array_config.find(x => x.configuracao_evento_id == item.configuracao_evento_id)
          if(cfg){
            cfg.recalculo = false
            cfg.frequencia_em_minutos = item.frequencia_em_minutos,
            cfg.valor_parametro= item.valor_parametro,
            cfg.quantidade_anterior_acumular=item.quantidade_anterior_acumular,
            cfg.valor_minimo = item.valor_minimo,
            cfg.valor_padrao = item.valor_padrao,
            cfg.valor_maximo = item.valor_maximo,
            cfg.criterio_diario = item.criterio_diario,
            cfg.quantidade_parametro_diario = item.quantidade_parametro_diario,
            cfg.ativo = this.normalizarAtivoConfiguracaoEvento(item.ativo)
          }
        })
      }

      if(estacao.estacao_coletas){
        const tipoVarIdsNaEstacao = new Set<number>();
        estacao.estacao_coletas.forEach(item => {
          tipoVarIdsNaEstacao.add(item.tipo_variavel_id);
          this.array_estacao_coletas.forEach(estacaoArray => {
            if (estacaoArray.tipo_variavel_id == item.tipo_variavel_id) {
              estacaoArray.recalculo = false;
              estacaoArray.fator_ajuste = item.fator_ajuste;
              estacaoArray.acrescimo_decrecimo_ajuste = item.acrescimo_decrecimo_ajuste;
              estacaoArray.casas_decimais = item.casas_decimais;
              // Se visualizar vier null/undefined, exibir como false na tela
              estacaoArray.visualizar = item.visualizar == null ? false : item.visualizar;
            }
          });
        });
        // Itens que não estão em estacao_coletas (não configurados para esta estação) exibem visualizar=false
        this.array_estacao_coletas.forEach(estacaoArray => {
          if (!tipoVarIdsNaEstacao.has(estacaoArray.tipo_variavel_id)) {
            estacaoArray.visualizar = false;
          }
        });
      }

      if(estacao.configuracoes_coleta && estacao.configuracoes_coleta.length > 0){
        estacao.configuracoes_coleta.forEach(item => {
          this.array_config_coleta.push(item)
        })
      } else {
        // Estação existente sem configurações de coleta: carregar ao menos uma linha para o usuário definir qual configuração de coleta será usada
        this.addConfigColeta()
      }

      this.sensorIdVinculado = estacao.sensor?.id ?? null
      this.transmissorIdentificador = estacao.sensor?.identificador ?? ''
      this.form.get('sensor_id').setValue(this.sensorIdVinculado)

      
      
      this.displayModal = true
      this.iniciarCarregamentoLogs(estacao.id, 1);
      if (this.isViewMode) {
        this.disableAllFields();
      }
      },
      error: () => {
        this.idEstacaoCarregando = null;
        this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'Não foi possível carregar os dados da estação.' });
      },
      complete: () => {
        this.idEstacaoCarregando = null;
      }
    });
  }
  openNew(){
    this.cancelarCarregamentoLogs();
    this.resetarHistoricoVazao();
    this.isViewMode = false;
    this.array_config_coleta = []
    this.form.reset()
    this.sensorIdVinculado = null
    this.transmissorIdentificador = ''
    this.form.get('exibir_vazao').setValue(false)
    this.form.get('ativo').setValue(true)
    this.form.get('desativar_coleta').setValue(false)
    this.form.get('desativar_integracao').setValue(false)
    this.listConfiguracaoEvento()
    this.listVariaveis()
    this.addConfigColeta()
    this.displayModal = true
    this.array_vazao = []
    this.array_vazao_inicial = []
    this.estadoVazaoInicial = this.capturarEstadoVazaoFormulario()
    this.integracoes = []
    this.array_integracao = []
    this.deletedIntegrations = [] // Limpar array de exclusões ao abrir novo formulário
    this.logs = []
    this.logsTotalRecords = 0
    this.rowsLogs = 50
    this.logsCurrentPage = 1
    this.logsLoaded = false
    this.loadingLogs = false
    this.activeTabIndex = 0;
    this.estacao = null;
  }

  disableAllFields() {
    Object.keys(this.form.controls).forEach(key => {
      this.form.get(key)?.disable();
    });
  }

  enableAllFields() {
    Object.keys(this.form.controls).forEach(key => {
      this.form.get(key)?.enable();
    });
  }

  removeConfig(event){
   event.ativo = false
   this.updateSelectedConfiguracoes()
   if(this.array_config.length > 1){
    this.array_config.map(item => {
      this.dropDownConfiguracaoEvento = this.dropDownConfiguracaoEvento.map(option => ({
        ...option,
        disabled: this.selectedConfiguracoes.includes(option.value) && option.value !== item.configuracao_evento_id
      }));
  
    })
  
  }
  }
  activeTabIndex: number = 0;

  addConfigColeta(){
   
    this.array_config_coleta.push({
      configuracao_coleta_id: null,
      tipo_descodificacao_id: null,
      arquivo_ftp_padrao: null
    })
  }

  listVariaveis(forceRefresh = false){
    const cacheKey = 'tipoVariavel';
    if (!forceRefresh && this.lookupCache.has(cacheKey)) {
      this.applyTipoVariavelFromApi(this.lookupCache.get<any[]>(cacheKey) || []);
      return;
    }

    this._variavelService.getType().subscribe(json => {
      this.lookupCache.set(cacheKey, json);
      this.applyTipoVariavelFromApi(json);
    })
  }

  private applyTipoVariavelFromApi(json: any[]): void {
    this.dropDownTipoVariavel = []
    this.array_estacao_coletas = []
    json.map(item => {
      if (item.id!==4){
        this.dropDownTipoVariavel.push({
          label: item.tipo_variavel, value: item.id
        })

        if(this.form.get('id').value == null){
          this.array_estacao_coletas.push({
            tipo_variavel_id: item.id,
            fator_ajuste: 1,
            acrescimo_decrecimo_ajuste: 0,
            casas_decimais: null,
            recalculo: null,
            visualizar: true,
          })
        } else {
          this.array_estacao_coletas.push({
            tipo_variavel_id: item.id,
            fator_ajuste: 1,
            acrescimo_decrecimo_ajuste: 0,
            casas_decimais: null,
            recalculo: false,
            visualizar: true,
          })
        }
      }
    })
  }

  removeConfigColeta(event) {
    let arr = this.array_config_coleta.filter(x => { return x !== event });

    this.array_config_coleta = []

    this.array_config_coleta = arr;
  }

  /**
   * Garante que configuracoes_coleta seja enviada com ids primitivos (não objetos) e
   * que cada par (configuracao_coleta_id, tipo_descodificacao_id) seja enviado apenas 1x ao back-end.
   * O p-dropdown às vezes vincula o objeto inteiro; a API espera configuracao_coleta_id e tipo_descodificacao_id como número ou null.
   */
  private normalizarConfiguracoesColeta(arr: any[]): any[] {
    if (!arr || !Array.isArray(arr)) return [];
    const normalizados = arr.map(item => ({
      id: item.id ?? undefined,
      configuracao_coleta_id: item.configuracao_coleta_id != null && typeof item.configuracao_coleta_id === 'object'
        ? (item.configuracao_coleta_id.value ?? null)
        : (item.configuracao_coleta_id ?? null),
      tipo_descodificacao_id: item.tipo_descodificacao_id != null && typeof item.tipo_descodificacao_id === 'object'
        ? (item.tipo_descodificacao_id.value ?? null)
        : (item.tipo_descodificacao_id ?? null),
      arquivo_ftp_padrao: item.arquivo_ftp_padrao ?? null
    }));
    // Deduplicar: enviar cada par (configuracao_coleta_id, tipo_descodificacao_id) apenas 1x
    const vistos = new Set<string>();
    return normalizados.filter(item => {
      const key = `${item.configuracao_coleta_id ?? ''}|${item.tipo_descodificacao_id ?? ''}`;
      if (vistos.has(key)) return false;
      vistos.add(key);
      return true;
    });
  }

  addConfig(){
    if(this.form.get('id').value == null){
      this.array_config.push({
        configuracao_evento_id: null,
        frequencia_em_minutos: null,
        valor_parametro: null,
        quantidade_anterior_acumular: null,
        valor_minimo: null,
        valor_padrao: null,
        valor_maximo: null,
        criterio_diario: null,
        quantidade_parametro_diario: null,
        ativo: true,
        recalculo: null,
      })
    } else {
      this.array_config.push({
        configuracao_evento_id: null,
        frequencia_em_minutos: null,
        valor_parametro: null,
        quantidade_anterior_acumular: null,
        valor_minimo: null,
        valor_padrao: null,
        valor_maximo: null,
        criterio_diario: null,
        quantidade_parametro_diario: null,
        ativo: true,
        recalculo: false,
      })
    }
   

if(this.array_config.length > 1){
  this.array_config.map(item => {
    this.dropDownConfiguracaoEvento = this.dropDownConfiguracaoEvento.map(option => ({
      ...option,
      disabled: this.selectedConfiguracoes.includes(option.value) && option.value !== item.configuracao_evento_id
    }));

  })

}

}

updateSelectedConfiguracoes() {
  this.selectedConfiguracoes = []
  this.array_config.map(item => {
    if(item.ativo == true){
      this.selectedConfiguracoes.push(
        item.configuracao_evento_id
      )
    }
    
  })
  
  
}
   
  

hasArrayChanged(arr1, arr2) {
  if (arr1.length !== arr2.length) return true;
  return arr1.some((item, index) => item !== arr2[index]);
}

  /** Extrai id numérico de valor que pode ser número ou objeto (ex.: dropdown). */
  private extrairId(val: any): number | null {
    if (val == null) return null
    if (typeof val === 'number' && !Number.isNaN(val)) return val
    if (typeof val === 'object' && (val.value != null || val.id != null)) return val.value ?? val.id
    const n = Number(val)
    return Number.isNaN(n) ? null : n
  }

  private adicionarTiposEventoPorVariavel(tipoEventoList: number[], tipoVariavelId: number | null): void {
    if (tipoVariavelId == null) return

    const mapaVariavelEvento: { [key: number]: number[] } = {
      1: [1, 2],
      2: [3, 4, 5],
      3: [6, 9],
      5: [6, 9],
    }

    ;(mapaVariavelEvento[tipoVariavelId] || []).forEach((tipoEventoId) => {
      if (!tipoEventoList.includes(tipoEventoId)) tipoEventoList.push(tipoEventoId)
    })
  }

  saveDataRecalculo(){
    const estacaoId = this.form.get('id')?.value
    const dataRecalculo = this.dataRecalculo ? moment(this.dataRecalculo).format('YYYY-MM-DD') : null
    if (estacaoId == null || estacaoId === '' || !dataRecalculo || dataRecalculo === 'Invalid date') {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Preencha a data "Recalcular a partir" e salve a estação com ID válido.'
      })
      return
    }

    const tipoVariavelIds: number[] = []
    ;(this.array_estacao_coletas_copia || []).forEach((item: any) => {
      const id = this.extrairId(item.tipo_variavel_id)
      if (id != null && !tipoVariavelIds.includes(id)) tipoVariavelIds.push(id)
    })

    const tipoEventoIds: number[] = []
    ;(this.array_config_copia || []).forEach((item: any) => {
      const eventoId = this.extrairId(item.configuracao_evento_id)
      if (eventoId != null && !tipoEventoIds.includes(eventoId)) tipoEventoIds.push(eventoId)
    })

    if (tipoVariavelIds.length === 0 && tipoEventoIds.length === 0) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Marque ao menos uma configuração de evento ou de coleta para recálculo.'
      })
      return
    }

    const params = {
      tipo_variavel_ids: tipoVariavelIds,
      tipo_evento_ids: tipoEventoIds,
      estacao_id: Number(estacaoId),
      data_inicio: dataRecalculo,
      data_filtro: dataRecalculo,
    }

    this._resumoEventoDiaService.remake(params).subscribe({
      next: (res) => {
        this.modalDataRecalculo = false
        this.messageService.add({
          severity: 'success',
          summary: 'Enfileirado',
          detail: res?.message || 'Recálculo enfileirado. O processamento continua em background.'
        })
      },
      error: (err) => {
        const msg = err?.error?.message || 'Erro ao enfileirar recálculo.'
        this.messageService.add({
          severity: err?.status === 409 ? 'warn' : 'error',
          summary: err?.status === 409 ? 'Em andamento' : 'Erro',
          detail: msg
        })
      }
    })
  }

closeDialog() {
  this.fecharDialogEstacao();
}

fecharDialogEstacao(): void {
  this.displayModal = false;
}

onDialogEstacaoHide(): void {
  this.cancelarCarregamentoLogs();
  this.resetarHistoricoVazao();
  this.isViewMode = false;
  this.enableAllFields();
  this.activeTabIndex = 0;
  this.resetTabs();
  this.logs = [];
  this.logsTotalRecords = 0;
  this.rowsLogs = 50;
  this.logsCurrentPage = 1;
  this.logsLoaded = false;
  this.loadingLogs = false;
}


save() {
  if (this.loading) return;
  if (!this.form.get('id')?.value) {
    this.form.patchValue({
      tipo_integracao: 2
    });
  }

  if (!this.coletaIntegracaoEmEstadoValido()) {
    this.messageService.add({
      severity: 'warn',
      summary: 'Atenção',
      detail: 'Não é possível manter a integração ativa enquanto a coleta estiver desativada. Desative a integração ou ative a coleta.',
    });
    return;
  }

  const semNenhumaConfig = this.array_config_coleta.length === 0;
  const algumItemIncompleto = this.array_config_coleta.some((item: any) => {
    const configVazio = item.configuracao_coleta_id == null || item.configuracao_coleta_id === '' || item.configuracao_coleta_id === 'null';
    const tipoDescVazio = item.tipo_descodificacao_id == null || item.tipo_descodificacao_id === '';
    return configVazio || tipoDescVazio;
  });
  if (!this.form.get('desativar_coleta')?.value && (semNenhumaConfig || algumItemIncompleto)) {
    this.messageService.add({
      severity: 'warn',
      summary: 'Atenção',
      detail: semNenhumaConfig
        ? 'Informe ao menos uma configuração de coleta na aba Configurações coleta.'
        : 'Preencha "Configuração coleta" e "Tipo de descodificação" em todos os itens da aba Configurações coleta. Não deixe em "Selecione".',
    });
    this.activeTabIndex = 2;
    return;
  }

  this.loading = true;
  let form = this.form.value;
  let params = form;
  params.configuracoes_evento = this.prepararConfiguracoesEventoParaEnvio()
  params.configuracoes_coleta = this.normalizarConfiguracoesColeta(this.array_config_coleta)
  params.estacao_coletas = this.array_estacao_coletas
  // O vínculo do transmissor é somente leitura nesta tela. Ao editar,
  // preserva-se o vínculo carregado da estação; ao criar, ele é omitido.
  if (form.id != null && this.sensorIdVinculado != null) {
    params.sensor = { id: this.sensorIdVinculado };
  } else {
    delete params.sensor;
  }
  if (form.ativo == true) {
    params.status = 0;
  } else {
    params.status = 1;
  }

  params.cliente_id = form.cliente_id != null ? Number(form.cliente_id) : null;

  params.configuracoes_vazao = this.array_vazao.map(item => {
    const { intervalo, ...rest } = item;
    return rest;
  });

  // Garantir que origem da vazão seja enviada como 0 (Vazão calculada) ou 1 (Vazão via API) conforme o radiogroup
  const tipoOrigemVazao = this.form.get('tipo_origem_vazao')?.value;
  params.tipo_origem_vazao = tipoOrigemVazao == null
    ? null
    : ((tipoOrigemVazao === 1 || tipoOrigemVazao === '1') ? 1 : 0);
  params.configuracao_vazao_historico_origem_id = this.configuracaoVazaoHistoricoOrigemId;

  // params.configuracoes_integracao = this.integracoes?.map((item) => item.value);
  
  if (form.id == null) {
    params.configuracao_integracao_estacao = this.array_integracao.map(item => ({
      configuracao_integracao_id: item.configuracao_estacao_id,
      configuracao_usuario_integracao: item.configuracao_usuario_integracao,
      configuracao_senha_integracao: item.configuracao_senha_integracao,
      tag: item.tag,
    }));
    this._estacaoService.store(params).subscribe(json => {
     
        this.loading = false;
        this.index();
        this.listEstacoesFiltro(true);
        this.closeDialog();
        this.deletedIntegrations = []; // Limpar array de exclusões após criar
        // this.displayModal = false;
    }, err => {
      this.loading = false;
    });
  } else {
    // Integrações novas (que ainda não foram salvas - não têm estacao_id)
    const newIntegrations = this.array_integracao
      .filter(item => !item.estacao_id)
      .map(item => ({
        estacao_id: form.id,
        configuracao_integracao_id: item.configuracao_estacao_id,
        configuracao_usuario_integracao: item.configuracao_usuario_integracao,
        configuracao_senha_integracao: item.configuracao_senha_integracao,
        tag: item.tag,
        createdAt: true,
      }));
    
    // Integrações existentes que foram mantidas (já salvas - têm estacao_id mas não têm senha no array)
    const currentIntegrations = this.array_integracao
      .filter(item => item.estacao_id && !item.configuracao_senha_integracao)
      .map((item) => ({
        id: item.id,
        estacao_id: form.id,
        configuracao_integracao_id: item.configuracao_estacao_id,
        configuracao_usuario_integracao: item.configuracao_usuario_integracao,
        tag: item.tag,
      }));
    
    // Usar o array de exclusões que foi preenchido quando o usuário clicou em excluir
    // As integrações excluídas já estão no formato correto: { id: X, deletedAt: true }
    params.configuracao_integracao_estacao = [...newIntegrations, ...currentIntegrations, ...this.deletedIntegrations];
    this._estacaoService.update(params, form.id).subscribe(json => {
    
        this.loading = false;
        this.index();
        this.listEstacoesFiltro(true);
        this.displayModal = false;
        this.array_config_copia = (this.array_config || []).filter(x => x.recalculo == true && x.ativo == true)
        this.array_estacao_coletas_copia = (this.array_estacao_coletas || []).filter(x => x.recalculo == true)
        this.modalDataRecalculo = this.array_config_copia.length > 0 || this.array_estacao_coletas_copia.length > 0
    }, err => {
      this.loading = false;
    });
  }
  this.array_integracao = [];
  this.deletedIntegrations = []; // Limpar array de exclusões após salvar
}

  index(){
    this.loadGridData(1, this.perPage);
    this.array_vazao = [];
    this.integracoes = [];
  }

  private getGridFilters(): EstacaoGridFilters {
    const grupos = (this.grupo || []).map(item => item.value);
    const estacoes = (this.estacoesFiltro || []).map(item => item.value);
    const clientes = (this.cliente || []).map(item => item.value);
    const sensores = (this.sensor || []).map(item => item.value);
    const integradores = (this.integrador_filtro || []).map(item => item.value);
    const coletores = (this.coletor_filtro || []).map(item => item.id);

    return {
      search: this.searchTerm,
      grupoList: grupos,
      clienteList: clientes,
      sensorList: sensores,
      plu: this.plu_filtro,
      flu: this.flu_filtro,
      integradorList: integradores,
      coletorList: coletores,
      estacoes_ids: estacoes.length > 0 ? estacoes : undefined,
    };
  }

  private loadGridData(page: number, perPage: number): void {
    const filters = this.getGridFilters();

    this.loading = true;

    this._estacaoService.listGrid({
      page,
      per_page: perPage,
      ...filters,
    }).subscribe({
      next: (json: any) => {
        this.data = json?.data || [];
        this.totalRecords = json?.total || 0;
        this.currentPage = json?.current_page || page;
        this.perPage = json?.per_page || perPage;
        this.gridFirst = (this.currentPage - 1) * this.perPage;
        this.loading = false;
        setTimeout(() => {
          this.calculateScrollHeight();
        }, 100);
      },
      error: () => {
        this.data = [];
        this.totalRecords = 0;
        this.loading = false;
      }
    });
  }

  addNovoGrupo(){
    this.modalNovoGrupo = true
   }
  
   aoSalvarNovoGrupo(): void {
    this.lookupCache.delete('grupos');
    this.listGrupos(true)
    this.modalNovoGrupo = false;
  }

  abrirModalReprocessamento(estacao: any): void {
    this.dataHoraReprocessamento = null;
    this.dataFinalReprocessamentoColeta = null;
    this.pararPollingReprocessamentos();
    this.estacaoReprocessamento = {
      id: estacao.id,
      descricao: estacao.descricao,
    };
    this.modalOpcoesReprocessamento = true;
    this.carregarListaReprocessamentos();
    this.iniciarPollingReprocessamentos();
  }

  abrirModalReprocessarColetar(): void {
    if (this.temConflitoColetaAtivo()) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Em andamento',
        detail: 'Já existe coleta ou recálculo conflitante em andamento para esta estação no período.'
      });
      return;
    }
    this.dataHoraReprocessamento = null;
    this.dataFinalReprocessamentoColeta = null;
    this.modalReprocessamento = true;
  }

  abrirModalReprocessarIntegracao(): void {
    if (this.temConflitoIntegracaoAtivo()) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Em andamento',
        detail: 'Já existe integração em andamento para esta estação no período selecionado.'
      });
      return;
    }
    this.dataInicialIntegracao = null;
    this.dataFinalIntegracao = null;
    this.modalPeriodoIntegracao = true;
  }

  cancelarOpcoesReprocessamento(): void {
    this.modalOpcoesReprocessamento = false;
    this.estacaoReprocessamento = null;
    this.pararPollingReprocessamentos();
    this.listaReprocessamentos = [];
  }

  carregarListaReprocessamentos(): void {
    if (!this.estacaoReprocessamento?.id) return;
    this.loadingListaReprocessamentos = true;
    this._estacaoService.listReprocessamentos(this.estacaoReprocessamento.id).subscribe({
      next: (res) => {
        this.listaReprocessamentos = (res?.data || []) as ReprocessamentoListItem[];
        this.loadingListaReprocessamentos = false;
      },
      error: () => {
        this.loadingListaReprocessamentos = false;
      }
    });
  }

  /** Evita unknown no template com pipe slice. */
  logsReprocessamentoPreview(item: ReprocessamentoListItem): ReprocessamentoLogItem[] {
    return (item?.logs || []).slice(0, 5);
  }

  iniciarPollingReprocessamentos(): void {
    this.pararPollingReprocessamentos();
    this.pollReprocessamentosTimer = setInterval(() => {
      if (!this.modalOpcoesReprocessamento || !this.estacaoReprocessamento?.id) {
        this.pararPollingReprocessamentos();
        return;
      }
      this.carregarListaReprocessamentos();
    }, 5000);
  }

  pararPollingReprocessamentos(): void {
    if (this.pollReprocessamentosTimer) {
      clearInterval(this.pollReprocessamentosTimer);
      this.pollReprocessamentosTimer = null;
    }
  }

  get reprocessamentosAtivos(): any[] {
    return (this.listaReprocessamentos || []).filter((r) =>
      r.status === 'pendente' || r.status === 'processando'
    );
  }

  temConflitoColetaAtivo(): boolean {
    return this.reprocessamentosAtivos.some((r) =>
      r.tipo === 'coleta' || r.tipo === 'recalculo'
    );
  }

  temConflitoIntegracaoAtivo(): boolean {
    return this.reprocessamentosAtivos.some((r) => r.tipo === 'integracao');
  }

  labelStatusReprocessamento(status?: string): string {
    if (!status) return '';
    const map: Record<string, string> = {
      pendente: 'Pendente',
      processando: 'Processando',
      concluido: 'Concluído',
      erro: 'Erro',
    };
    return map[status] || status;
  }

  labelTipoReprocessamento(tipo?: string): string {
    if (!tipo) return '';
    const map: Record<string, string> = {
      recalculo: 'Recálculo',
      coleta: 'Coleta',
      integracao: 'Integração',
    };
    return map[tipo] || tipo;
  }

  /** Habilita o botão "Recalcular valores do nível" apenas quando exibir_vazao=true e tipo_origem_vazao=0 (Vazão calculada). */
  get podeRecalcularVazaoNivel(): boolean {
    const e = this.estacaoReprocessamento;
    return !!(e && e.exibir_vazao === true && e.tipo_origem_vazao === 0);
  }

  abrirModalRecalcularVazao(): void {
    if (!this.podeRecalcularVazaoNivel) return;
    this.modalOpcoesReprocessamento = false;
    this.dataInicialRecalcularVazao = null;
    this.dataFinalRecalcularVazao = null;
    this.modalRecalcularVazao = true;
  }

  cancelarRecalcularVazao(): void {
    this.modalRecalcularVazao = false;
    this.dataInicialRecalcularVazao = null;
    this.dataFinalRecalcularVazao = null;
    this.loadingRecalcularVazao = false;
  }

  /** Intervalo máximo em dias para o recálculo da vazão (conforme regra de negócio). */
  private readonly INTERVALO_MAXIMO_DIAS_RECALCULAR_VAZAO = 60;

  executarRecalcularVazao(): void {
    if (!this.estacaoReprocessamento?.id) return;
    const dataInicial = this.dataInicialRecalcularVazao;
    const dataFinal = this.dataFinalRecalcularVazao;
    if (!dataInicial || !dataFinal) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Data inicial e data final são obrigatórias.'
      });
      return;
    }
    const dIni = moment(dataInicial).startOf('day');
    const dFim = moment(dataFinal).startOf('day');
    const hoje = moment().startOf('day');
    if (dIni.isAfter(hoje) || dFim.isAfter(hoje)) {
      this.messageService.add({
        severity: 'error',
        summary: 'Erro',
        detail: 'As datas não podem ser posteriores à data de hoje.'
      });
      return;
    }
    if (dFim.isBefore(dIni)) {
      this.messageService.add({
        severity: 'error',
        summary: 'Erro',
        detail: 'A data final deve ser igual ou posterior à data inicial.'
      });
      return;
    }
    const dias = dFim.diff(dIni, 'days') + 1;
    if (dias > this.INTERVALO_MAXIMO_DIAS_RECALCULAR_VAZAO) {
      this.messageService.add({
        severity: 'error',
        summary: 'Erro',
        detail: `O intervalo entre as datas não pode ser maior que ${this.INTERVALO_MAXIMO_DIAS_RECALCULAR_VAZAO} dias.`
      });
      return;
    }
    this.loadingRecalcularVazao = true;
    const dataInicialStr = dIni.format('YYYY-MM-DD');
    const dataFinalStr = dFim.format('YYYY-MM-DD');
    this._lambdaVazaoService.consultar({
      estacao_id: this.estacaoReprocessamento.id,
      data_inicial: dataInicialStr,
      data_final: dataFinalStr,
    }).subscribe({
      next: (res) => {
        this.loadingRecalcularVazao = false;
        this.cancelarRecalcularVazao();
        if (res.success && res.data) {
          this.messageService.add({
            severity: 'success',
            summary: 'Sucesso',
            detail: 'Recálculo da vazão solicitado com sucesso.'
          });
        } else {
          this.messageService.add({
            severity: 'warn',
            summary: 'Atenção',
            detail: res.message || 'A Lambda retornou uma resposta inesperada.'
          });
        }
      },
      error: (err) => {
        this.loadingRecalcularVazao = false;
        const msg = err?.error?.message || err?.error?.errors ? this.extrairMensagensValidacao(err.error.errors) : 'Erro ao solicitar recálculo da vazão.';
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: msg
        });
      },
    });
  }

  private extrairMensagensValidacao(errors: Record<string, string[]>): string {
    if (!errors || typeof errors !== 'object') return 'Erro de validação.';
    const msgs = Object.values(errors).flat();
    return msgs.length ? msgs.join(' ') : 'Erro de validação.';
  }

  /**
   * Formata início/fim do período para a API de integração no fuso de Brasília (UTC−3),
   * alinhado ao filtro de dados de variável e aos timestamps das coletas.
   */
  private formatarPeriodoIntegracaoParaApi(inicio: Date, fim: Date): { dataInicio: string; dataFinal: string } {
    const ini = moment(inicio).utcOffset(-180).startOf('day');
    const fimD = moment(fim).utcOffset(-180).endOf('day');
    return {
      dataInicio: ini.format('YYYY-MM-DD HH:mm:ss'),
      dataFinal: fimD.format('YYYY-MM-DD HH:mm:ss'),
    };
  }

  cancelarPeriodoIntegracao(): void {
    this.modalPeriodoIntegracao = false;
    this.dataInicialIntegracao = null;
    this.dataFinalIntegracao = null;
  }

  processarIntegracao(): void {
    if (!this.dataInicialIntegracao) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Selecione a data inicial para reprocessamento de integração'
      });
      return;
    }

    if (!this.dataFinalIntegracao) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Selecione a data final para reprocessamento de integração'
      });
      return;
    }

    const dataInicial = moment(this.dataInicialIntegracao).utcOffset(-180).startOf('day');
    const dataFinal = moment(this.dataFinalIntegracao).utcOffset(-180).startOf('day');
    const hoje = moment().utcOffset(-180).startOf('day');

    if (dataInicial.isAfter(hoje)) {
      this.messageService.add({
        severity: 'error',
        summary: 'Erro',
        detail: 'A data inicial não pode ser posterior à data de hoje'
      });
      return;
    }

    if (dataFinal.isAfter(hoje)) {
      this.messageService.add({
        severity: 'error',
        summary: 'Erro',
        detail: 'A data final não pode ser posterior à data de hoje'
      });
      return;
    }

    if (dataFinal.isBefore(dataInicial)) {
      this.messageService.add({
        severity: 'error',
        summary: 'Erro',
        detail: 'A data final deve ser igual ou posterior à data inicial'
      });
      return;
    }

    this.modalPeriodoIntegracao = false;
    this.iniciarProcessamentoIntegracao();
  }

  iniciarProcessamentoIntegracao(): void {
    this.modalProgressoIntegracao = true;
    this.processandoIntegracao = true;
    this.concluidoIntegracao = false;
    this.resultadoIntegracaoMensagem = '';
    this.resultadoIntegracaoTipo = 'success';

    const { dataInicio: dataInicialFormatada, dataFinal: dataFinalFormatada } =
      this.formatarPeriodoIntegracaoParaApi(this.dataInicialIntegracao, this.dataFinalIntegracao);

    this._integracaoEnvioService.enviarDados(
      this.estacaoReprocessamento.id,
      dataInicialFormatada,
      dataFinalFormatada
    ).subscribe({
      next: (response) => {
        this.processandoIntegracao = false;
        const msg = response?.message
          ?? 'Envio enfileirado. O processamento continua em background; acompanhe na tela de reprocessamento.';
        if (response?.success || response?.queued) {
          this.concluidoIntegracao = true;
          this.resultadoIntegracaoMensagem = msg;
          this.resultadoIntegracaoTipo = 'warn';
          this.carregarListaReprocessamentos();
        } else {
          this.modalProgressoIntegracao = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Erro',
            detail: msg
          });
        }
      },
      error: (err) => {
        this.processandoIntegracao = false;
        this.modalProgressoIntegracao = false;
        const errorMsg = err?.error?.message || err?.message || 'Erro ao enviar dados de integração.';
        this.messageService.add({
          severity: err?.status === 409 ? 'warn' : 'error',
          summary: err?.status === 409 ? 'Em andamento' : 'Erro',
          detail: errorMsg
        });
        this.carregarListaReprocessamentos();
      }
    });
  }

  cancelarProcessamentoIntegracao(): void {
    this.processandoIntegracao = false;
    this.modalProgressoIntegracao = false;
    this.concluidoIntegracao = false;
  }

  fecharModalProgressoIntegracao(): void {
    this.modalProgressoIntegracao = false;
    this.concluidoIntegracao = false;
    this.resultadoIntegracaoMensagem = '';
    this.estacaoReprocessamento = null;
  }

  confirmarReprocessamento(): void {
    if (!this.dataHoraReprocessamento) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Selecione a data inicial para reprocessamento'
      });
      return;
    }

    const dataSelecionada = moment(this.dataHoraReprocessamento).startOf('day');
    const hoje = moment().startOf('day');

    if (dataSelecionada.isAfter(hoje)) {
      this.messageService.add({
        severity: 'error',
        summary: 'Erro',
        detail: 'A data não pode ser posterior à data de hoje'
      });
      return;
    }

    if (this.dataFinalReprocessamentoColeta) {
      const dataFinal = moment(this.dataFinalReprocessamentoColeta).startOf('day');
      if (dataFinal.isAfter(hoje)) {
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'A data final não pode ser posterior à data de hoje'
        });
        return;
      }
      if (dataFinal.isBefore(dataSelecionada)) {
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'A data final deve ser igual ou posterior à data inicial'
        });
        return;
      }
    }

    this.modalReprocessamento = false;
    this.modalConfirmacaoReprocessamento = true;
  }

  executarReprocessamento(): void {
    if (!this.estacaoReprocessamento || !this.dataHoraReprocessamento) {
      return;
    }

    this.loadingReprocessamento = true;
    const dataHoraFormatada = moment(this.dataHoraReprocessamento).format('YYYY-MM-DD') + ' 00:00:00';
    const dataFinalFormatada = this.dataFinalReprocessamentoColeta
      ? moment(this.dataFinalReprocessamentoColeta).format('YYYY-MM-DD') + ' 00:00:00'
      : undefined;

    this.onixsatService.buscarPorData(dataHoraFormatada, this.estacaoReprocessamento.id, dataFinalFormatada).subscribe({
      next: (resultado) => {
        this.loadingReprocessamento = false;
        this.modalConfirmacaoReprocessamento = false;
        const msg = resultado?.mensagem || resultado?.message
          || 'Reprocessamento de coleta enfileirado. O processamento continua em background.';
        this.messageService.add({
          severity: resultado?.queued || resultado?.sucesso || resultado?.success ? 'success' : 'info',
          summary: resultado?.queued ? 'Enfileirado' : 'Informação',
          detail: msg
        });
        this.carregarListaReprocessamentos();
      },
      error: (err) => {
        this.loadingReprocessamento = false;
        this.modalConfirmacaoReprocessamento = false;
        const errorMsg = err?.error?.message || err?.error?.mensagem || 'Erro ao enfileirar reprocessamento';
        this.messageService.add({
          severity: err?.status === 409 ? 'warn' : 'error',
          summary: err?.status === 409 ? 'Em andamento' : 'Erro',
          detail: errorMsg
        });
        this.carregarListaReprocessamentos();
      }
    });
  }

  formatarDataHora(dataHora: Date | string): string {
    return moment(dataHora).format('DD/MM/YYYY HH:mm:ss');
  }

  exportarRelatorio(): void {
    // Perguntar ao usuário qual formato deseja
    this.confirmationService.confirm({
      key: 'globalConfirm',
      message: 'Escolha o formato de exportação:',
      header: 'Exportar Relatório',
      icon: 'pi pi-file-export',
      acceptLabel: 'XLSX',
      rejectLabel: 'PDF',
      accept: () => {
        this.exportarXLSX();
      },
      reject: () => {
        if (!this.data || this.data.length === 0) {
          this.messageService.add({
            severity: 'warn',
            summary: 'Aviso',
            detail: 'Nenhuma estação disponível para exportar'
          });
          return;
        }
        this.exportarPDF();
      }
    });
  }


  prepararDadosBasicos(): any[] {
    return this.data.map((estacao: any) => ({
      'Descrição': estacao.descricao || '',
      'Cliente': estacao.cliente?.nome || '',
      'PLU': estacao.plu || '',
      'FLU': estacao.flu || '',
      'Localização': estacao.localizacao || '',
      'Latitude': estacao.latitude || '',
      'Longitude': estacao.longitude || '',
      'Data Instalação': estacao.data_instalacao ? moment(estacao.data_instalacao).format('DD/MM/YYYY') : '',
      'Status': estacao.status === 0 ? 'Ativo' : estacao.status === 1 ? 'Inativo' : '',
      'Intervalo Operação (min)': estacao.intervalo_operacao || '',
      'Visualizar': estacao.visualizar ? 'Sim' : 'Não',
    }));
  }

  exportarXLSX(): void {
    this.loading = true;
    const payload = this.getDownloadPayload();

    this._estacaoService.downloadLista(payload).subscribe({
      next: async (response: EstacaoDownloadListaResponse) => {
        try {
          const estacoes = this.getEstacoesParaDownload(response);

          if (!estacoes) {
            this.messageService.add({
              severity: 'error',
              summary: 'Erro',
              detail: 'A resposta do relatório de estações está em um formato inválido.'
            });
            return;
          }

          if (estacoes.length === 0) {
            this.messageService.add({
              severity: 'warn',
              summary: 'Aviso',
              detail: 'Nenhuma estação disponível para exportar'
            });
            return;
          }

          const dadosFormatados = this.prepararDadosParaExportacao(estacoes);
          await this.gerarArquivoXLSX(dadosFormatados);
        } catch {
          this.messageService.add({
            severity: 'error',
            summary: 'Erro',
            detail: 'Não foi possível gerar o arquivo XLSX.'
          });
        } finally {
          this.loading = false;
        }
      },
      error: () => {
        this.loading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Não foi possível gerar o relatório de estações.'
        });
      }
    });
  }

  private async gerarArquivoXLSX(dadosFormatados: any[]): Promise<void> {
    const xlsx = await import('xlsx');
    const worksheet = xlsx.utils.json_to_sheet(dadosFormatados);
    const workbook = { Sheets: { 'Estações': worksheet }, SheetNames: ['Estações'] };
    const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, 'Relatorio_Estacoes');
  }

  private getEstacoesParaDownload(response: unknown): EstacaoDownloadListaEstacao[] | null {
    if (!response || typeof response !== 'object' || !Array.isArray((response as EstacaoDownloadListaResponse).estacoes)) {
      return null;
    }

    return (response as EstacaoDownloadListaResponse).estacoes;
  }

  private getDownloadPayload(): EstacaoDownloadListaPayload {
    const filters = this.getGridFilters();

    return {
      search: filters.search || undefined,
      grupoList: filters.grupoList,
      clienteList: filters.clienteList,
      sensorList: filters.sensorList,
      plu: filters.plu,
      flu: filters.flu,
      integradorList: filters.integradorList,
      coletorList: filters.coletorList,
      estacoes_ids: filters.estacoes_ids,
    };
  }

  exportarPDF(): void {
    this.loading = true;
    const payload = this.getDownloadPayload();

    this._estacaoService.downloadLista(payload).subscribe({
      next: async (response: EstacaoDownloadListaResponse) => {
        try {
          const estacoes = this.getEstacoesParaDownload(response);

          if (!estacoes) {
            this.messageService.add({
              severity: 'error',
              summary: 'Erro',
              detail: 'A resposta do relatório de estações está em um formato inválido.'
            });
            return;
          }

          if (estacoes.length === 0) {
            this.messageService.add({
              severity: 'warn',
              summary: 'Aviso',
              detail: 'Nenhuma estação disponível para exportar'
            });
            return;
          }

          await this.gerarArquivoPDF(this.prepararDadosParaExportacao(estacoes));
        } catch (err) {
          console.error('Erro ao gerar PDF de estações:', err);
          this.messageService.add({
            severity: 'error',
            summary: 'Erro',
            detail: 'Não foi possível gerar o arquivo PDF.'
          });
        } finally {
          this.loading = false;
        }
      },
      error: (err) => {
        console.error('Erro ao buscar relatório de estações para PDF:', err);
        this.loading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Não foi possível gerar o relatório de estações.'
        });
      }
    });
  }

  private async gerarArquivoPDF(dadosFormatados: any[]): Promise<void> {
    const [jsPDFModule, autoTableModule] = await Promise.all([
      import('jspdf'),
      import('jspdf-autotable')
    ]);
    const JsPDFCtor = (jsPDFModule as any).jsPDF || (jsPDFModule as any).default || jsPDFModule;
    const autoTable = (autoTableModule as any).autoTable || (autoTableModule as any).default;

    if (typeof JsPDFCtor !== 'function' || typeof autoTable !== 'function') {
      throw new Error('Não foi possível carregar o módulo de exportação PDF.');
    }

    const doc = new JsPDFCtor({ orientation: 'landscape', unit: 'mm', format: 'a4' });
    const colunas = Object.keys(dadosFormatados[0]);
    const linhas = dadosFormatados.map(linha => colunas.map(coluna => String(linha[coluna] ?? '')));

    doc.setFontSize(14);
    doc.text('Relatório de Estações', 14, 15);
    doc.setFontSize(9);
    doc.text(`Gerado em: ${moment().format('DD/MM/YYYY HH:mm:ss')}`, 14, 21);

    autoTable(doc, {
      head: [colunas],
      body: linhas,
      startY: 26,
      margin: { top: 16, left: 8, right: 8, bottom: 10 },
      styles: { fontSize: 5.2, overflow: 'linebreak', cellPadding: 1 },
      headStyles: { fillColor: [66, 139, 202], fontStyle: 'bold' },
      columnStyles: {
        0: { cellWidth: 8 },
        2: { cellWidth: 10 },
        4: { cellWidth: 22 },
        5: { cellWidth: 25 },
        6: { cellWidth: 25 },
        7: { cellWidth: 14 },
        8: { cellWidth: 14 },
        10: { cellWidth: 15 },
        11: { cellWidth: 15 },
        12: { cellWidth: 16 },
        13: { cellWidth: 10 }
      },
      didDrawPage: (data: any) => {
        if (data.pageNumber > 1) {
          doc.setFontSize(9);
          doc.text('Relatório de Estações', 14, 10);
        }
      }
    });

    doc.save(`Relatorio_Estacoes_${moment().format('YYYY-MM-DD_HH-mm-ss')}.pdf`);
  }

  prepararDadosParaExportacao(estacoes: EstacaoDownloadListaEstacao[]): any[] {
    const dadosFormatados: any[] = [];

    estacoes.forEach((estacao: any) => {
      const estacaoFormatada: any = {
        id: estacao.id ?? '',
        descricao: estacao.descricao ?? '',
        cliente_id: estacao.cliente_id ?? '',
        cliente_nome: estacao.cliente_nome ?? '',
        transmissor_identificador: String(estacao.transmissor_identificador ?? ''),
        coletor_identificador: String(estacao.coletor_identificador ?? ''),
        integrador_identificador: String(estacao.integrador_identificador ?? ''),
        plu: estacao.plu ?? '',
        flu: estacao.flu ?? '',
        localizacao: estacao.localizacao ?? '',
        latitude: estacao.latitude ?? '',
        longitude: estacao.longitude ?? '',
        data_instalacao: estacao.data_instalacao ? moment(estacao.data_instalacao).format('YYYY-MM-DD') : '',
        status: estacao.status ?? '',
      };

      dadosFormatados.push(estacaoFormatada);
    });

    return dadosFormatados;
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_' + moment().format('YYYY-MM-DD_HH-mm-ss') + EXCEL_EXTENSION);
  }

  onGridLazyLoad(event: any): void {
    const rows = event?.rows || this.perPage;
    const page = Math.floor((event?.first || 0) / rows) + 1;
    this.currentPage = page;
    this.perPage = rows;
    this.gridFirst = event?.first || 0;
    this.loadGridData(page, rows);
  }

  onSearchInput(value: string): void {
    this.searchTerm = value || '';
    this.currentPage = 1;
    this.gridFirst = 0;

    if (this.searchDebounceHandle) {
      clearTimeout(this.searchDebounceHandle);
    }

    this.searchDebounceHandle = setTimeout(() => {
      this.loadGridData(1, this.perPage);
    }, 300);
  }
}
